import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import {DocumentsService } from '../services/documents.service';
import { DocumentsComponent } from '../documents/documents.component';
import { DocumentImageComponent } from '../document-image/document-image.component';
// import { SnotifyService } from '../../../node_modules/ng-snotify';
import { ConfirmSnackbarComponent } from '../confirm-snackbar/confirm-snackbar.component';
import { LoaderService } from '../services/loader.service';
import { FeedbackService } from '../services/feedback.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.css']
})
export class DocumentListComponent implements OnInit {
  isPopupOpenOpened = true;
  docImage = true;
  public documents;
  public doclist;
  public _data = '';
  public dataExists = false;
  constructor(private _feedbackService: FeedbackService,
              private bottomSheet: MatBottomSheet, private _loaderService: LoaderService, private log: LogService, private snackbar?: MatSnackBar,
              private dialog?: MatDialog, private _documentsService?:DocumentsService) { }

  ngOnInit() {
    this._loaderService.emitChange(true);
    this.log
      .addLog({
      action: "Access",
      component: "Document List",
      details: `Access Document List`,
    }).subscribe(data => { });
    this._documentsService.displayDocs().subscribe(data=>{
      if(data.success === false){
        this._data = 'You have not uploaded any document here';
        this.dataExists = false;
      }else{
        this.doclist = data;
        this._data = '';
        this.dataExists = true;
      }
      this._loaderService.emitChange(false);
    })
  }
  get DocumentList(){
    return this._documentsService.getAllDocs();
  }
  addDocument(){
    this.isPopupOpenOpened = true;
    const dialogRef = this.dialog.open(DocumentsComponent,{
      data:{},
    });
 
  dialogRef.afterClosed().subscribe(result =>{
    if (result) {
      if (result.success) {
        this.snackbar.open(result.message, 'close', {
          duration: 3000
        });
        this.log
          .addLog({
          action: "Upload",
          component: "Document List",
          details: `Uploaded document with title ${result.doc_title}`,
        }).subscribe(data => { });
      } else {
        this.snackbar.open(result.message, 'close', {
          duration: 3000
        });
      }
    }
    this.isPopupOpenOpened = false;
    this._loaderService.emitChange(true);
    this._documentsService.displayDocs().subscribe(data=>{
      if(data.success === false){
        this._data = 'You have not uploaded any document here';
        this.dataExists = false;
      }else{
        this.doclist = data;
        this._data = '';
        this.dataExists = true;
      }
      this._loaderService.emitChange(false);
    })
  });

}
showImage(event){
  let doc = event;
  this._documentsService.getDoc(doc);
  this.docImage = true;
  const imageDialog = this.dialog.open(DocumentImageComponent,{
    data:{ doc },
    maxWidth:'75%'
  })
}
delImage(id, title){
  this._loaderService.emitChange(true);
  this._documentsService.deleteDocument(id).subscribe(data=>{
    if(data){
      this._feedbackService.emitChange("Deletion successful", "primary-color");
      this.log
        .addLog({
        action: "Delete",
        component: "Document List",
        details: `Deleted document with title - ${title}`,
      }).subscribe(data => { });
      this._documentsService.displayDocs().subscribe(data=>{
        if(data.success === false){
          this._data = 'You have not uploaded any document here';
          this.dataExists = false;
        }else{
          this.doclist = data;
          this._data = '';
          this.dataExists = true;
        }
      })
    }else{
      this._feedbackService.emitChange("Failed. Please try again", "failed-color");
    }
    this._loaderService.emitChange(false)
  });

}
deleteImage(event){
  let id = event.doc_id;
  console.log(event);
  let sheetRef = this.bottomSheet.open(ConfirmSnackbarComponent,{
    data:{message:"Are you sure?", button1: 'yes', button2: 'no'}
 })
  sheetRef.afterDismissed().subscribe(data => {
    if(data){
      if(data.response){
        this.delImage(id, event.title);
      }
    }
  })
      



}


}
